import { BooleanInput, Edit, SimpleForm, TextInput } from 'react-admin';
import { CustomTitle } from '../../components/CustomTitle';
import { SpeakerInput } from './SpeakerInput';
import { DatesField, RichText, LocationField, PathssField, TagssField } from './fields';

// import { validateForm } from './validate';

export const SessionEdit = (_props: unknown) => {
  return (
    <Edit title={<CustomTitle />}>
      <SimpleForm
      // validate={validateForm}
      >
        <TextInput source="title" fullWidth />
        <DatesField />

        <LocationField />
        <SpeakerInput source="speakersId" />
        <TagssField />
        <PathssField />
        <RichText source="details" />
        <BooleanInput source="isSponsored" />
      </SimpleForm>
    </Edit>
  );
};
